import type { WidgetKey } from '../types'

/**
 * Key query của dashboard: ['dashboard', userId, widgetKey, params?].
 * userId đứng thứ 2 để xoá cache theo người dùng bằng removeQueries({ queryKey: ['dashboard', userId] }).
 */
export const dashboardQueryKeys = {
  all: ['dashboard'] as const,
  user: (userId: string | undefined) => ['dashboard', userId ?? 'anonymous'] as const,
  widget: (userId: string | undefined, widgetKey: WidgetKey, params?: Record<string, unknown>) =>
    params
      ? (['dashboard', userId ?? 'anonymous', widgetKey, params] as const)
      : (['dashboard', userId ?? 'anonymous', widgetKey] as const),
}

interface WidgetQueryConfig {
  staleTime: number
  refetchOnWindowFocus?: boolean
}

/** Bảng staleTime / refetchOnWindowFocus theo plan-cache.md task C6. */
export const WIDGET_QUERY_CONFIG: Record<WidgetKey, WidgetQueryConfig> = {
  'overview-kpis': { staleTime: 60_000, refetchOnWindowFocus: false },
  'dossiers-by-status': { staleTime: 60_000, refetchOnWindowFocus: false },
  'my-documents': { staleTime: 2 * 60_000 },
  'my-dossiers': { staleTime: 2 * 60_000 },
  'outbox-status': { staleTime: 30_000, refetchOnWindowFocus: true },
  'trusted-ca-expiry': { staleTime: 10 * 60_000, refetchOnWindowFocus: false },
  'my-sign-activity': { staleTime: 2 * 60_000 },
  'issue-waiting-age': { staleTime: 60_000, refetchOnWindowFocus: true },
  'issued-by-dossier-type': { staleTime: 5 * 60_000 },
  'issued-by-week': { staleTime: 5 * 60_000 },
  'documents-by-month': { staleTime: 5 * 60_000 },
  'my-pending-signatures': { staleTime: 15_000, refetchOnWindowFocus: true },
}
